import {QuickConfigData} from '../domain/QuickConfigData';

export class ProductOptionUtils {
  static findFieldInResponse(fieldId: string, response) {
    return response['categories'].map(category => category.parentSubcategories)
      .reduce((result, parentSubcat) => result.concat(parentSubcat), []) // flatten the parentSubcategories
      .map(parentSubcat => parentSubcat.subcategories)
      .reduce((result, subcat) => result.concat(subcat), []) // flatten the subcategories
      .map(subcategory => subcategory.fields)
      .reduce((result, field) => result.concat(field), []) // flatten the fields
      .find(field => field.id === fieldId);
  }

  static findSubcatInResponse(subcatId: string, response) {
    return response['categories'].map(category => category.parentSubcategories)
      .reduce((result, parentSubcat) => result.concat(parentSubcat), []) // flatten the parentSubcategories
      .map(parentSubcat => parentSubcat.subcategories)
      .reduce((result, subcat) => result.concat(subcat), []) // flatten the subcategories
      .find(subcat => subcat.id === subcatId);
  }

  static flattenSubcategories(quickConfigInitData: QuickConfigData) {
    return quickConfigInitData.categories.map(category => category.parentSubcategories)
      .reduce((result, parentSubcat) => result.concat(parentSubcat), []);
  }

  static findFieldInCategoriesWithData(fieldId: string, categories): { field, subcatId, parentSubcatId, categoryId } {
    return categories.map(category =>
      category.parentSubcategories.map(parentSubcat => {
        return {
          parentSubcat: parentSubcat,
          categoryId: category.id
        };
      }))
      .reduce((result, parentSubcat) => result.concat(parentSubcat), []) // flatten the parentSubcategories
      .map(parentSubcat => parentSubcat.parentSubcat.subcategories
        .map(subcat => {
          return {
            subcat: subcat,
            parentSubcatId: parentSubcat.parentSubcat.id,
            categoryId: parentSubcat.categoryId
          };
        }))
      .reduce((result, subcat) => result.concat(subcat), []) // flatten the subcategories
      .map(subcategory => subcategory.subcat.fields
        .map(field => {
          return {
            field: field,
            subcatId: subcategory.subcat.id,
            parentSubcatId: subcategory.parentSubcatId,
            categoryId: subcategory.categoryId
          };
        }))
      .reduce((result, field) => result.concat(field), [])// flatten the fields
      .find(field => {
        return field.field.id === fieldId;
      });
  }
}
